import type { QontoEmberPartialConfig, QontoRegisterJSReactConfig } from '../../config/environment';

declare const process: { env: Record<string, string | undefined> } | undefined;
declare const __PLAYWRIGHT_TEST__: boolean | undefined;

export const DEFAULT_TESTING_ENVIRONMENT_VARIABLES = {
  backendBranchName: 'qa',
  backendUrlMode: 'local',
  branchName: '',
  checkout: {
    publicKey: 'pk_test_example',
    apiBaseUrl: 'https://api.sandbox.checkout.com',
  },
  deployTarget: 'staging',
  eksClusterId: '',
  environment: 'test',
  frontendBranchName: 'sandbox',
  frontendEksClusterId: '',
  frontendUrlMode: 'development',
  googlePay: {
    merchantId: 'test-merchant-id',
  },
  isProduction: false,
  isStaging: false,
  qontoEventGatewayUrl: '',
  refinerProjectId: '',
  stagingAccessToken: '',
  useLocal: false,
} satisfies QontoEmberPartialConfig;

export const getEnvironmentVariables = <
  QontoConfig extends QontoRegisterJSReactConfig | QontoEmberPartialConfig =
    QontoEmberPartialConfig,
>() => {
  if (
    (typeof __PLAYWRIGHT_TEST__ !== 'undefined' && __PLAYWRIGHT_TEST__) ||
    (typeof process !== 'undefined' &&
      // oxlint-disable-next-line typescript/no-unnecessary-condition
      (Boolean(process?.env.PLAYWRIGHT_TEST) || Boolean(process?.env.VITEST)))
  ) {
    return DEFAULT_TESTING_ENVIRONMENT_VARIABLES as QontoConfig;
  }
  const metaTag =
    typeof document !== 'undefined'
      ? document.querySelector("meta[name$='/config/environment']")
      : null;

  const content = metaTag?.getAttribute('content') || '{}';

  try {
    const decodedContent = decodeURIComponent(content);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return JSON.parse(decodedContent) as QontoConfig;
  } catch (error) {
    console.error('Failed to parse environment variables from meta tag:', error);
    // oxlint-disable-next-line typescript/consistent-type-assertions
    return {} as QontoConfig;
  }
};
